import React, { useState } from 'react';
import { DatePicker, Button, Space, Row } from 'antd';
import { Spacing } from 'works/legacy/lib/style-helper';
import { Moment } from 'moment';

const { RangePicker } = DatePicker;
const dateFormat = 'MM/DD/YYYY';

// Type that satisfies the current type constraints
// it would be better if it were just a list of moment
type ChangeValue = (Moment | string | null)[] | null;

export const DateRangeFilter = ({
  onChange,
  onSearch,
  defaultValue = [],
  autoFocus,
}: {
  onChange?: (search: ChangeValue) => void;
  onSearch?: (search: ChangeValue) => void;
  // @TODO: let it accept all type of data by transforming it internally in a momment instance
  defaultValue?: Moment[];
  autoFocus: boolean;
}) => {
  const [queryString, setQueryString] = useState<ChangeValue>(defaultValue);

  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: Spacing.baseSpacing / 2,
        }}
      >
        <RangePicker
          autoFocus={autoFocus}
          defaultValue={[defaultValue[0], defaultValue[1]]}
          onChange={(value) => {
            setQueryString(value);
            onChange?.(value);
          }}
          format={dateFormat}
          placeholder={['From date', 'To date']}
        />
      </Space>
      <Row justify="end">
        <Button
          type="primary"
          onClick={() => {
            onSearch?.(queryString);
            setQueryString(null);
          }}
          size="small"
          style={{ width: 90 }}
        >
          Apply
        </Button>
      </Row>
    </>
  );
};
